import { render, staticRenderFns } from "./ModifyDataCentrePackageModal.vue?vue&type=template&id=e845b5e2&"
import script from "./ModifyDataCentrePackageModal.vue?vue&type=script&lang=js&"
export * from "./ModifyDataCentrePackageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports